module.exports = __webpack_public_path__ + "img/Jump Casting64.990922d6.jpg";